import useAsyncData from "../../../../hooks/use-async-data";
import driverService from "../../driver.service";
import DriverTaxiDriverAssociations from "./driver-taxi-driver-associations";
import DriverTaxiDriverAssociationsError from "./driver-taxi-driver-associations-error";
import DriverTaxiDriverAssociationsParams from "./driver-taxi-driver-associations-params";

const useTaxiDriverAssociations = () => {
  const { isLoading, setIsLoading, isError, setIsError, data, setData } =
    useAsyncData<DriverTaxiDriverAssociations | null>(null);

  const load = async (
    params: DriverTaxiDriverAssociationsParams,
    signal: AbortSignal,
  ): Promise<void> => {
    setIsLoading(true);
    setIsError(false);

    try {
      const driverTaxiDriverAssociations =
        await driverService.getTaxiDriverAssociations(params, signal);

      setData(driverTaxiDriverAssociations);
    } catch (_error) {
      const error = _error as DriverTaxiDriverAssociationsError;

      setIsError(true);
    } finally {
      setIsLoading(false);
    }
  };

  return {
    isLoading,
    isError,
    data,
    load,
  };
};

export default useTaxiDriverAssociations;
